// TODO: bodyにクラスをつける処理だけでいいのでは？

// https://github.com/DamonOehlman/detect-browser/blob/33a4e24e2d8271b5ec7b7dfcc6ec96b7d6ab4f71/src/index.ts
const regexps = {
  legacyEdge: /Edge\/([0-9\._]+)/,
  chromiumEdge: /Edg\/([0-9\.]+)/,
  firefox: /Firefox\/([0-9\.]+)(?:\s|$)/,
  chrome: /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
  safari: /Version\/([0-9\._]+).*Safari/,
  ie: /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/,
};

class UserAgent {
  browser = {};

  detect() {

    this.browser = {
      isLegacyEdge: false,
      chromiumEdge: false,
      firefox: false,
      chrome: false,
      safari: false,
      ie: false
    };

    if ('userAgentData' in window.navigator) {
      // userAgentDataが有効なのでchrome。
      // 既存のuserAgentは使用不可
      this.browser.isChrome = true;
      return;
    };

    for (const [name, regexp] of Object.entries(regexps)) {
      const matched = regexp.test(navigator.userAgent);
      if (!matched) {
        continue;
      }

      switch (name) {
        case 'legacyEdge':
          this.browser.isLegacyEdge = true;
          break;
        case 'chromiumEdge':
          this.browser.isChromiumEdge = true;
          break;
        case 'firefox':
          this.browser.isFirefox = true;
          break;
        case 'chrome':
          this.browser.isChrome = true;
          break;
        case 'safari':
          this.browser.isSafari = true;
          break;
        case 'ie':
          this.browser.isIE = true;
          break;
      }
      break;
    }
  }

  constructor() {
    // this.agent = navigator.userAgent;
    // this.ppVersion = navigator.appVersion.toLowerCase();
    this.detect();
    // this.device = {
    //   isMac: this.agent.indexOf('Mac') >= 0,
    //   isIPad: /iPad/.test(this.agent),
    //   isIOS: /iP(hone|od|ad)/.test(this.agent),
    //   isAndroid: this.agent.indexOf('Android') > -1,
    // };

    /*
    /* 追加デバイス判定
    **/
    // this.device.isMobile = this.device.isIOS || this.device.isAndroid;
    // if (this.device.isAndroid) {
    //   this.device.isAndroidTablet = this.agent.indexOf('Mobile') < 0;
    //   this.device.isAndroidMobile = !this.device.isAndroidTablet;
    // } else {
    //   this.device.isAndroidTablet = false;
    //   this.device.isAndroidMobile = false;
    // }

    //   this.device.isSmartPhone = false;
    //   if (this.device.isMobile) {
    //     if (
    //       this.agent.indexOf('iPhone') > -1 ||
    //       (this.device.isAndroid && !this.device.isAndroidTablet)
    //     ) {
    //       this.device.isSmartPhone = true;
    //     }
    //   }
  }
}

export default new UserAgent();
